import { Paper } from "@mui/material";
import ModalForm from "App/Components/Modals/Components/ModalForm";
import Modal from "App/Components/Modals/Modal";
import Breadcrumb from "App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { PageContainer } from "App/Components/PageContainer/PageContainer";
import ListSkeleton from "App/Components/Skeleton/ListSkeleton";
import { RandomTextSkeleton } from "App/Components/Skeleton/RandomTextSkeleton";
import { useModalHooks } from "App/State/Hooks/useModalHooks";
import { FeatureFlags } from "App/Typings/FeatureFlags";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useGetFeatureQuery } from "Pages/ABAC/AbacAppQueries";
import { useParams } from "react-router-dom";
import CreateAttributeForm from "../../../Attributes/Components/CreateAttributeForm";
import useCreateAttributeFormState from "../../../Attributes/State/CreateAttributeFormState";
import { FeatureDetailsForm } from "./Components/FeatureDetailsForm";

export function ManageFeature() {
  const { appId, featureId } = useParams<{
    appId: string;
    featureId: string;
  }>();
  const { data: currentFeature, isLoading } = useGetFeatureQuery(featureId);

  // Initialize EnableABACApplicationManagement LD flag
  // TODO: Remove with ABAC-32
  const { enableAbacApplicationManagement } = useFlags<FeatureFlags>();

  const {
    getters: { createAttributeFormTitle, createIsLoading, formik },
    handlers: { handleCreateModalClose },
  } = useCreateAttributeFormState(appId, featureId);

  const { modalStatus } = useModalHooks();

  if (!enableAbacApplicationManagement) {
    return null;
  }

  if (isLoading) {
    return (
      <PageContainer>
        <p>Loading...</p>
      </PageContainer>
    );
  }

  if (!isLoading && currentFeature) {
    const manageFeatureBreadcrumbs = [
      {
        breadCrumbName: "ABAC Apps",
        route: `abac`,
      },
      {
        breadCrumbName: currentFeature.app.name,
        route: `abac/${currentFeature.app.id}`,
      },
    ];

    return (
      <PageContainer>
        <Breadcrumb
          pageTitle={currentFeature.name}
          isLoading={isLoading}
          customBreadcrumbs={manageFeatureBreadcrumbs as any}
        />
        <h1 className="page-title">
          {!isLoading ? "Manage " + currentFeature.name : <RandomTextSkeleton />}
        </h1>
        <Paper sx={{ mt: 4, mb: 4, p: { xs: 2, lg: 4 } }}>
          {!isLoading ? (
            <>
              <FeatureDetailsForm feature={currentFeature!} />
            </>
          ) : (
            <ListSkeleton numRows={5} />
          )}
        </Paper>
        <Modal
          fullWidth
          maxWidth="sm"
          open={modalStatus.open === true}
          title={createAttributeFormTitle}
          hasLoadingBar={true}
          isProcessing={createIsLoading}
          handleClose={() => handleCreateModalClose()}
        >
          <ModalForm formik={formik} isProcessing={createIsLoading}>
            <CreateAttributeForm />
          </ModalForm>
        </Modal>
      </PageContainer>
    );
  }
}
